import "../styles/dashboard.css";
import { useNavigate } from "react-router-dom";
import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import NumbersList from "../components/NumbersList/NumbersList";
import React, { useState } from "react";
import SearchBox from "../components/SearchBox/SearchBox";

const Numbers = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <>
      <NotificationHeader name="Numbers" />
      <div className="dashboardPage">
        <div className="container">
          <div className="pageStyle">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <SearchBox onSearch={handleSearch} />
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="text-end">
                  <button
                    className="primaryBtn text-uppercase"
                    onClick={() => {
                      navigate("/billing");
                    }}
                    type="button"
                  >
                    Buy More Numbers
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <NumbersList searchTerm={searchTerm} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Numbers;
